import React from "react"

function IconArrowRedo({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="arrow-redo"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-arrow-redo"{...props}><path d="M11.906 3.307a8.818 8.818 0 0 1 8.8 8.265h2.45l-3.257 4.592-3.282-4.593h2.777a7.51 7.51 0 1 0-1.69 5.324l.82 1.056a8.818 8.818 0 1 1-6.618-14.644z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconArrowRedo
